import { API } from '@Providers';

// NOTE :: This sends the same body as the finish call (the full cart, plus payment_type,
// name_on_card, and split_payment_details) without the card. The api sets the payment amount
// from the cart in the session, not from this body. The browser never decides the amount.
// TODO - AF-545 - Missing interface for cart data
export default async function (payload: any) {
  const endpoint = '/api/shelter/cart/create-payment-intent';

  return API({ endpoint, method: 'post', payload });
}
